import { BANK_UNVERIFIED_NOTE } from "@/shared/import/bank-statutory-import-fields";

interface Props {
  created: number;
  /// Captured at commit time from the confirmed mapping, so a later Slack
  /// sync in the same wizard never inherits it.
  bankUnverified?: boolean;
  /// The dry run warned that some rows import with fields skipped.
  fieldsSkipped?: boolean;
}

/// Follow-ups a reader needs after a people import: who got an invitation,
/// that bank accounts from the file cannot be paid until confirmed, and that
/// fields the file could not supply are still to be filled in.
export function PeopleImportDoneNote({ created, bankUnverified, fieldsSkipped }: Props) {
  if (created === 0 && !bankUnverified && !fieldsSkipped) return null;
  return (
    <div className="flex flex-col gap-1 text-xs text-text-secondary">
      {created > 0 ? (
        <p>
          Invitation emails have been sent to {created} new {created === 1 ? "person" : "people"}.
        </p>
      ) : null}
      {fieldsSkipped ? (
        <p>
          Some fields were skipped because the file had values we could not accept. Complete them
          from each person's profile.
        </p>
      ) : null}
      {bankUnverified ? (
        <p className="font-medium text-text-primary">{BANK_UNVERIFIED_NOTE}</p>
      ) : null}
    </div>
  );
}
